import type { SubscribeToAiDraftEvents } from 'lib-knowledge-management';

import { pubSub } from 'utils/pubSub';

/**
 * Relays the web socket's AI draft events, which the websocket saga publishes
 * on `pubSub`, to the knowledge management lib — which cannot reach either.
 */
export const subscribeToAiDraftEvents: SubscribeToAiDraftEvents = ({
  onUpserted,
  onDeleted,
  onLockChanged,
  onReconnected,
}) => {
  const disposers = [
    pubSub.subscribe('ai_draft:upserted', ({ ai_draft_id }) =>
      onUpserted(ai_draft_id),
    ),
    pubSub.subscribe('ai_draft:deleted', ({ ai_draft_id }) =>
      onDeleted(ai_draft_id),
    ),
    pubSub.subscribe('ai_draft:lock_changed', ({ ai_draft_id, is_locked }) =>
      onLockChanged(ai_draft_id, is_locked),
    ),
    pubSub.subscribe('webSocketReconnected', onReconnected),
  ];

  return () => disposers.forEach((dispose) => dispose());
};
